import React from "react";

export default function Commission({ type, summary }) {
  const map = {
    earned: {
      title: "Total Commission",
      value: `$${summary.total_commission_value || summary.total_commission_earned}`,
      sub: "",
      color: "green"
    },

    pending_approval: {
      title: "Pending Approval",
      value: `$${summary.pending_approval}`,
      sub: `From ${summary.pending_approval_projects} projects`,
      color: "orange"
    },

    pending_payout: {
      title: "Pending Payout",
      value: `$${summary.pending_payout}`,
      sub: `From ${summary.pending_payout_projects} projects`,
      color: "blue"
    },

    leads: {
      title: "Total Leads",
      value: summary.total_leads,
      sub: "",
      color: "purple"
    }
  };

  const data = map[type];

  return (
    <div className={`kpi-card ${data.color}`}>
      <div className="kpi-title">{data.title}</div>
      <div className="kpi-value">{data.value}</div>
      <div className="kpi-sub">{data.sub}</div>
    </div>
  );
}